module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-6-c6b9e1909c9c64775807a3dc3bb928bd.jpg";